import { create } from 'zustand';
import { adminLoVManagementApi } from '@api/api-config.ts';
import { AdminPortalLoVResponse } from '@api/generated/portal-be-admin';

interface AdminPortalState {
  portals: AdminPortalLoVResponse[];
  loading: boolean;
  error: string | null;
}

interface AdminPortalActions {
  fetchPortals: () => Promise<void>;
  clearError: () => void;
}

type AdminPortalStore = AdminPortalState & AdminPortalActions;

export const useAdminPortalStore = create<AdminPortalStore>(set => ({
  // State
  portals: [],
  loading: false,
  error: null,

  // Actions
  fetchPortals: async () => {
    set({ loading: true, error: null });

    try {
      const response = await adminLoVManagementApi.getPortals();
      set({
        portals: response.data || [],
        loading: false,
      });
    } catch (error) {
      set({
        error: error instanceof Error ? error.message : 'Chyba při načítání portálů',
        loading: false,
      });
    }
  },

  clearError: () => {
    set({ error: null });
  },
}));
